/* eslint-disable css-modules/no-unused-class */
import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import withResponsiveWrapper from '../../decorators/withResponsiveWrapper';
import Grid from '../../components/Grid/Grid';
import Skeleton from '../../components/Skeleton/Skeleton';
import productStyle from './Product.scss';
import s from './ProductSkeleton.scss';

const ProductSkeleton = ({ isMobile }) => {
  return (
    <Grid container spacing={16} className={productStyle.main}>
      <Grid item xs={24} sm={24} md={5}>
        <div className={cx(productStyle.panel, productStyle.gallery)}>
          <Skeleton width="100%" height="154px" />
        </div>
      </Grid>
      <Grid item xs={24} sm={24} md={11}>
        <div
          className={cx(
            productStyle.panel,
            productStyle.padding,
            productStyle.noPaddingMobile,
          )}
        >
          <Grid
            container
            spacing={16}
            className={cx(
              productStyle.summary,
              productStyle.mobilePanel,
              isMobile && productStyle.space,
            )}
          >
            <Grid item md={4} className="hidden-xs">
              <Skeleton width="87px" height="87px" />
            </Grid>
            <Grid item sm={24} md={20} className={cx('sm-align-center')}>
              <Skeleton width="100%" height="26px" />
              <Skeleton width="100%" height="20px" className={s.skeleton} />
            </Grid>
            {isMobile && (
              <div className={cx(productStyle.carousel, s.usps)}>
                <div>
                  <Skeleton circle width="36px" height="36px" />
                  <Skeleton
                    width="125px"
                    height="12px"
                    className={s.uspsText}
                  />
                </div>
              </div>
            )}
          </Grid>
          {!isMobile && (
            <div className={cx(productStyle.padding, s.usps)}>
              <div className={s.usp}>
                <Skeleton circle width="36px" height="36px" />
                <div className={s.uspsText}>
                  <Skeleton width="90px" height="12px" />
                  <Skeleton width="80px" height="12px" />
                </div>
              </div>
              <div className={s.usp}>
                <Skeleton circle width="36px" height="36px" />
                <div className={s.uspsText}>
                  <Skeleton width="90px" height="12px" />
                  <Skeleton width="80px" height="12px" />
                </div>
              </div>
              <div className={s.usp}>
                <Skeleton circle width="36px" height="36px" />
                <div className={s.uspsText}>
                  <Skeleton width="90px" height="12px" />
                  <Skeleton width="80px" height="12px" />
                </div>
              </div>
              <div className={s.usp}>
                <Skeleton circle width="36px" height="36px" />
                <div className={s.uspsText}>
                  <Skeleton width="90px" height="12px" />
                  <Skeleton width="80px" height="12px" />
                </div>
              </div>
            </div>
          )}
          <div className={cx(productStyle.padding, productStyle.mobilePanel)}>
            <div className={s.paragraph}>
              <Skeleton width="100%" height="17px" />
              <Skeleton width="100%" height="17px" />
              <Skeleton width="90%" height="17px" />
            </div>
            <div className={s.paragraph}>
              <Skeleton width="100%" height="17px" />
              <Skeleton width="100%" height="17px" />
              <Skeleton width="80%" height="17px" />
            </div>
            <div className={s.paragraph}>
              <Skeleton width="100%" height="17px" />
              <Skeleton width="100%" height="17px" />
              <Skeleton width="90%" height="17px" />
            </div>
            <div className={s.paragraph}>
              <Skeleton width="100%" height="17px" />
              <Skeleton width="100%" height="17px" />
              <Skeleton width="80%" height="17px" />
            </div>
            <div className={s.paragraph}>
              <Skeleton width="100%" height="17px" />
              <Skeleton width="100%" height="17px" />
              <Skeleton width="90%" height="17px" />
            </div>
          </div>
        </div>
      </Grid>
      {!isMobile && (
        <Grid item md={8}>
          <div
            className={cx(
              productStyle.panel,
              productStyle.padding,
              productStyle.widthFix,
            )}
          >
            <div className={s.input}>
              <Skeleton width="75px" height="20px" />
              <Skeleton width="100%" height="39px" />
            </div>
            <div className={s.input}>
              <Skeleton width="75px" height="20px" />
              <Skeleton width="100%" height="39px" />
            </div>
            <div className={s.input}>
              <Skeleton width="75px" height="20px" />
              <Skeleton width="100%" height="39px" />
            </div>
            <div className={s.input}>
              <Skeleton width="75px" height="20px" />
              <Skeleton width="100%" height="39px" />
            </div>
            <div className={s.input}>
              <Skeleton width="75px" height="20px" />
              <Skeleton width="100%" height="39px" />
            </div>
            <div className={s.greeting}>
              <Skeleton width="70px" height="70px" />
              <div className={s.greetingText}>
                <Skeleton width="100%" height="20px" />
                <Skeleton width="100%" height="20px" />
                <Skeleton width="75%" height="20px" />
              </div>
              <Skeleton circle width="56px" height="56px" />
            </div>
            <div className={s.button}>
              <Skeleton width="100%" height="38px" />
            </div>
          </div>
        </Grid>
      )}
    </Grid>
  );
};

ProductSkeleton.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default compose(
  withResponsiveWrapper(),
  withStyles(productStyle, s),
)(ProductSkeleton);
